import { notify } from '@billy/design-system'
import type { TFunction } from 'i18next'

import { NotificationKeys } from '../../../../../../../enums/notificationKeys'

export const getNotifySaveError = (t: TFunction): (() => void) => {
  return () => {
    notify({
      id: NotificationKeys.ExternalInvoiceSettingsUpdate,
      message: t('error_saving'),
      variant: 'error',
    })
  }
}
